import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
        fetchingState: 'not-fetched', // not-fetched, fetching, fetched
		forms: {},
		formsArray: []
	}),

	getters: {
		allForms(state) {
			return state.formsArray;
		},
        activeForms(state) {
            return state.formsArray.filter((f) => !f.archived_at && !f.deleted_at);
        },
        archivedForms(state) {
            return state.formsArray.filter((f) => f.archived_at && !f.deleted_at);
        },
        deletedForms(state) {
            return state.formsArray.filter((f) => f.deleted_at);
        },
        formsWithArchived(state) {
            return state.formsArray.filter((f) => !f.deleted_at);
        },
        getFormById: (state) => (id) => {
            return state.forms[id] || null;
        }
	},

	actions: {
		async getForm({commit}, id) {
			// If form exists in store, return it
			if (this.state.forms.forms[id]) {
				return this.state.forms.forms[id];
			}
			
			// Otherwise fetch from API
			const response = await api.getForm(id);
			commit('addForm', response.data);
			return response.data;
		},
		
		async getAllForms({commit}, force = false) {
            if (!force && this.state.forms.fetchingState !== 'not-fetched') {
                return this.getters['forms/allForms'];
            }

			commit('setFetchingState', 'fetching');
			const response = await api.getAllForms();
			commit('setForms', response.data);
			return response.data;
		},
		
		async createForm({commit}, {title, templateFormId = null}) {
			let response;
			if (templateFormId) {
				response = await api.duplicateForm(templateFormId, title);
			} else {
				response = await api.createForm(title);
			}
			
			const newForm = response.data.form || response.data;
			commit('addForm', newForm);
			return newForm;
		},
		
		async updateForm({commit}, formData) {
			const response = await api.updateForm(formData);
			const updatedForm = response.data;
			commit('updateForm', updatedForm);
			return updatedForm;
		},
		
		async deleteForm({commit}, formId) {
			const response = await api.deleteForm(formId);
			commit('removeForm', formId);
			return response;
		},
		
		async toggleFormArchive({commit}, {formId, type}) {
			const response = await api.toggleFormIsArchived(formId, type);
			const updatedForm = response.data;
			commit('updateForm', updatedForm);
			return updatedForm;
		}
	},

	mutations: {
		setFetchingState(state, fetchingState) {
			state.fetchingState = fetchingState;
		},
        setForms(state, forms) {
            // Clear existing forms
            state.forms = {};
            
            forms.forEach((f) => {
                Vue.set(state.forms, f.id, f);
            });
            Vue.set(state, 'formsArray', Object.values(state.forms));
            state.fetchingState = 'fetched';
        },
        addForm(state, form) {
            Vue.set(state.forms, form.id, form);
            Vue.set(state, 'formsArray', Object.values(state.forms));
        },
        updateForm(state, updatedForm) {
            if (state.forms[updatedForm.id]) {
                Vue.set(state.forms, updatedForm.id, updatedForm);
                Vue.set(state, 'formsArray', Object.values(state.forms));
            }
        },
        removeForm(state, formId) {
            if (state.forms[formId]) {
                Vue.delete(state.forms, formId);
                Vue.set(state, 'formsArray', Object.values(state.forms));
            }
        }
	},
} 